export default __webpack_public_path__ + "static/media/newLogo.f5a48bf8.png";